var exports = {
  "kL": "AttachmentFile.module__container___RFZhZU",
  "G5": "AttachmentFile.module__deleteButton___RFZhZU",
  "Dq": "AttachmentFile.module__attachmentContainer___RFZhZU",
  "zc": "AttachmentFile.module__iconContainer___RFZhZU",
  "el": "AttachmentFile.module__fileInfoContainer___RFZhZU",
  "Md": "AttachmentFile.module__fileName___RFZhZU",
  "m$": "AttachmentFile.module__fileNameTruncate___RFZhZU",
  "i_": "AttachmentFile.module__fileExtension___RFZhZU",
  "Ov": "AttachmentFile.module__fileSize___RFZhZU",
  "l6": "AttachmentFile.module__downloadButton___RFZhZU",
  "Hj": "AttachmentFile.module__downloadButtonDisabled___RFZhZU",
};

module.exports = exports;
